//
//
//
//
//
//
//
//
//
//
//
//

import work_bench_item from "@/components/work_bench_item";
import "@/assets/css/reset.css";
import "@/assets/css/global.css";

export default {
  components: { work_bench_item },
  data() {
    return {
      indexData: {},
      work_bench_item1: [
        {
          img: "images/20_07.png",
          text: "会员参与情况",
          link: this.$api.host + "/mMis/PrizeStockOutJoinOrder"
        },
        {
          img: "images/2_10.png",
          text: "优惠券核销记录",
          link: this.$api.host + "/mMis/MemberCouponOrder/Index"
        }
      ],
      work_bench_item2: [
        {
          img: "images/20_14.png",
          text: "产品积分核销",
          // link: "/mSms/PrizeStockOutProductOrder"
          link: this.$api.host + "/mSms/PrizeStockOutProductOrder/Index"
        },
        {
          img: "images/31_11.png",
          text: "积分兑换记录",
          // link: "/mSms/MemberPointsOutExchangeOrder"
          link: this.$api.host + "/mSms/MemberPointsOutExchangeOrder/Index"
        },
        {
          img: "images/31_11.png",
          text: "积分兑换记录(门店自提)",
          // link: "/mSms/MemberPointsOutExchangeOrderForShop"
          link:
            this.$api.host + "/mSms/MemberPointsOutExchangeOrderForShop/Index"
        },
        {
          img: "images/2_10.png",
          text: "门店自提扫码",
          // link: "/mSms/MemberCouponOrderPiao"
          action: "onClickScanBtn"
        },
        {
          img: "images/1_26.png",
          text: "兑换补货出库单",
          // link: "/mSms/MemberCouponOrder"
          link: this.$api.host + "/mSms/DealerStockOutExchangeOrder"
        }
      ]
    };
  },
  computed: {},

  async onLoad() {},

  created() {},

  methods: {
    onClickScanBtn() {
      wx.scanQRCode({
        needResult: 0,
        scanType: ["qrCode"],
        success: res1 => {
          console.log("开始扫码", res1);
        },
        fail: err => this.err_toast(err)
      });
    }
  }
};
